/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*

*/

import React, { useEffect } from 'react';
import { View, TouchableOpacity, ScrollView, Dimensions } from 'react-native';

import Colors from '@global/colors';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Image from '@components/global/Image';
import ModalFull from '@components/modal/ModalFull';
import SociollaText from '@components/sociolla/SociollaText';
import Input from '@components/form/Input';
import Button from '@components/form/Button';
import {
  Wrapper,
  FormWrapper,
  FormGroup,
  ButtonSticky,
} from '@components/screen/Layout';
import { isWeb, isAndroid, isNative, isMobileWeb } from '@global/screens';
const dimension = Dimensions.get('screen');
const heightContainer = isWeb
  ? dimension.height - 200
  : isMobileWeb
  ? dimension.height - 55
  : 0;
import { isVn } from '@global/helpers';

const SelectRangeRules = ({
  show,
  value, // value of specific type
  onChange, // on change callback
  selectedBox,
  setSelectedBox = () => {},
  onClose = () => {},
  showList = {}, // show list based on type
  setShowList = () => {},
  mode = 'quantity',
}) => {
  const currency = isVn() ? 'VND' : 'IDR';
  const isAmountMode = mode === 'amount';
  const fromField = isAmountMode ? 'from_amount' : 'from_qty';
  const toField = isAmountMode ? 'to_amount' : 'to_qty';
  const fromLabel = isAmountMode ? 'From Amount' : 'From Quantity';
  const toLabel = isAmountMode ? 'To Amount' : 'To Quantity';
  const unitLabel = isAmountMode ? currency : 'pcs';
  const modalTitle = isAmountMode ? 'Add Range Amount' : 'Add Range Quantity';

  const showAddProduct = show ? true : false; // show or hide add product popup
  useEffect(() => {
    let mounted = true;
    if (mounted && value?.length) {
      setSelectedBox(value);
    }
    return () => {
      mounted = false;
    };
  }, []);

  // remove selected value
  const onRemoveItem = (index) => {
    try {
      const result = JSON.parse(JSON.stringify(selectedBox));
      result.splice(index, 1);
      setSelectedBox(result);
      onChange(result);
    } catch (error) {}
  };

  const FormProductValidationSchema = Yup.object().shape({
    [fromField]: Yup.number().required(`${fromLabel} is required.`),
    [toField]: Yup.number().required(`${toLabel} is required.`),
    deduction_percentage: Yup.number().required(
      'Deducation Percentage is required.',
    ),
  });

  return (
    <View style={{ width: '100%', marginBottom: 15 }}>
      <View style={{ width: '100%' }}>
        {/* Start List Container */}
        <ModalFull
          show={showAddProduct}
          title={modalTitle}
          onClose={() => {
            onClose();
          }}>
          <Formik
            initialValues={{
              [fromField]: '',
              [toField]: '',
              deduction_percentage: '',
            }}
            validationSchema={FormProductValidationSchema}
            onSubmit={(values) => {
              const item = {
                [fromField]: values[fromField],
                [toField]: values[toField],
                deduction_percentage: values.deduction_percentage,
              };

              const result = JSON.parse(JSON.stringify(selectedBox));
              const finalData = result.concat(item);
              setSelectedBox(finalData);
              onChange(finalData);
              setShowList({ ...showList });
              onClose(); // close add product popup
            }}>
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              errors,
              touched,
              values,
            }) => (
              <>
                <Wrapper fullWidth style={{ paddingBottom: isWeb ? 0 : 55 }}>
                  <ScrollView
                    style={
                      isWeb
                        ? { maxHeight: heightContainer }
                        : isMobileWeb
                        ? { height: heightContainer }
                        : {}
                    }>
                    <View
                      style={{
                        width: '100%',
                        paddingHorizontal: 10,
                        paddingVertical: 15,
                        marginBottom: isNative
                          ? isAndroid
                            ? 140
                            : 70
                          : isMobileWeb
                          ? 55
                          : 0,
                      }}>
                      <FormWrapper>
                        <View
                          style={{
                            width: '100%',
                            flexDirection: isWeb ? 'row' : 'column',
                            ...(isWeb
                              ? { justifyContent: 'space-between' }
                              : {}),
                          }}>
                          <View style={{ width: isWeb ? '48%' : '100%' }}>
                            <FormGroup>
                              <Input
                                label={fromLabel}
                                value={
                                  values[fromField]
                                    ? values[fromField].toString()
                                    : ''
                                }
                                keyboardType="numeric"
                                isNumeric
                                isRequired
                                editable={true}
                                onChangeText={(value) => {
                                  setFieldValue(fromField, value);
                                }}
                                hasError={
                                  errors[fromField] && touched[fromField]
                                    ? errors[fromField]
                                    : null
                                }
                              />
                              <SociollaText
                                style={{
                                  position: 'absolute',
                                  right: -25,
                                  top: 40,
                                }}>
                                {unitLabel}
                              </SociollaText>
                            </FormGroup>
                            <FormGroup>
                              <Input
                                label={toLabel}
                                value={
                                  values[toField]
                                    ? values[toField].toString()
                                    : ''
                                }
                                keyboardType="numeric"
                                isNumeric
                                isRequired
                                editable={true}
                                hasError={
                                  errors[toField] && touched[toField]
                                    ? errors[toField]
                                    : null
                                }
                                onChangeText={(value) => {
                                  setFieldValue(toField, value);
                                }}
                              />
                              <SociollaText
                                style={{
                                  position: 'absolute',
                                  right: -25,
                                  top: 40,
                                }}>
                                {unitLabel}
                              </SociollaText>
                            </FormGroup>
                            <FormGroup>
                              <Input
                                label="Percent Discount"
                                value={
                                  values.deduction_percentage
                                    ? values.deduction_percentage.toString()
                                    : ''
                                }
                                keyboardType="numeric"
                                isDecimal
                                isRequired
                                editable={true}
                                hasError={
                                  errors.deduction_percentage &&
                                  touched.deduction_percentage
                                    ? errors.deduction_percentage
                                    : null
                                }
                                onChangeText={(value) => {
                                  setFieldValue('deduction_percentage', value);
                                }}
                              />
                              <SociollaText
                                style={{
                                  position: 'absolute',
                                  right: -20,
                                  top: 40,
                                }}>
                                %
                              </SociollaText>
                            </FormGroup>
                          </View>
                        </View>
                        <>
                          {isWeb ? (
                            <View
                              style={{
                                width: '100%',
                                paddingTop: 20,
                                paddingBottom: 20,
                                alignItems: 'center',
                              }}>
                              <Button
                                rounded
                                buttonStyle={{ width: 150 }}
                                title={
                                  <SociollaText
                                    type="bold"
                                    style={{
                                      fontSize: 14,
                                      letterSpacing: 0.5,
                                      color: Colors.white,
                                    }}>
                                    Save
                                  </SociollaText>
                                }
                                onPress={handleSubmit}
                              />
                            </View>
                          ) : (
                            <ButtonSticky
                              show
                              customHost="modal-sticky-button"
                              buttons={[
                                {
                                  title: 'Save',
                                  onPress: (e) => handleSubmit(e),
                                },
                              ]}
                            />
                          )}
                        </>
                      </FormWrapper>
                    </View>
                  </ScrollView>
                </Wrapper>
              </>
            )}
          </Formik>
        </ModalFull>
      </View>
      {/* End List Container */}
      {/* Start Result Container */}
      {selectedBox?.length ? (
        <ScrollView
          contentContainerStyle={{ width: '100%', maxHeight: 250 }}
          showsVerticalScrollIndicator={isWeb}>
          <View
            style={{
              width: '100%',
              flexDirection: 'row',
              alignItems: 'center',
              flexWrap: 'wrap',
              marginTop: 15,
            }}>
            {(selectedBox || []).map((item, idx) => (
              <TouchableOpacity
                activeOpacity={0.8}
                style={{
                  backgroundColor: Colors.blue6,
                  paddingHorizontal: 12,
                  paddingVertical: 7,
                  marginLeft: 5,
                  borderRadius: 12,
                  marginVertical: 5,
                  minHeight: 19,
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  maxWidth: '97%',
                }}
                key={idx}>
                <SociollaText style={{ fontSize: 11, marginRight: 15 }}>
                  {/* {['product', 'free_product'].includes(type)
                    ? `${item?.brand?.name ? `${item.brand.name} - ` : ''}`
                    : ''}
                  {item.name} */}
                  {item[fromField]} - {item[toField]} discount{' '}
                  {item.deduction_percentage}%
                </SociollaText>
                <TouchableOpacity onPress={() => onRemoveItem(idx)}>
                  <Image
                    width={8}
                    height={8}
                    style={{ width: 8, height: 8 }}
                    svg={true}
                    source={require('@assets/img/icons/close-grey.svg')}
                  />
                </TouchableOpacity>
              </TouchableOpacity>
            ))}
          </View>
        </ScrollView>
      ) : (
        false
      )}
      {/* End Result Container */}
    </View>
  );
};

export default SelectRangeRules;
